export default "/static/featured/banner.jpg"